export enum SortOrder {
  ASC = 0,
  DESC,
}

export const sortOrderChoices = [
  { id: SortOrder.ASC, name: 'ASC' },
  { id: SortOrder.DESC, name: 'DESC' },
];
